import { ArrowRight, Clock, MapPinned, Phone } from "lucide-react";
import { COMPANY, TRUST_ITEMS } from "../lib/constants";
import { createWhatsAppLink } from "../lib/whatsapp";

export function Hero() {
  return (
    <section className="hero-section" data-testid="hero-section">
      <div className="hero-copy" data-testid="hero-copy">
        <div className="hero-kicker" data-testid="hero-kicker"><Clock size={16} /> Atendimento 24 horas em Arujá/SP</div>
        <h1 data-testid="hero-title">Guincho 24 Horas em Arujá/SP</h1>
        <p data-testid="hero-subtitle">Auto Socorro Pedrinho oferece guincho, reboque e socorro mecânico com atendimento rápido em Arujá, Rodovia Presidente Dutra e região.</p>
        <div className="hero-actions" data-testid="hero-actions">
          <a className="btn btn-primary-red" href={createWhatsAppLink()} data-testid="hero-whatsapp-button">Chamar no WhatsApp <ArrowRight size={18} /></a>
          <a className="btn btn-glass" href={COMPANY.phoneHref} data-testid="hero-phone-button"><Phone size={18} /> Ligar Agora</a>
          <a className="btn btn-ghost-yellow" href="#servicos" data-testid="hero-services-button">Ver Serviços</a>
        </div>
        <div className="trust-strip" data-testid="trust-strip">
          {TRUST_ITEMS.map((item, index) => <span key={item} data-testid={`trust-item-${index}`}>{item}</span>)}
        </div>
      </div>
      <div className="hero-media" data-testid="hero-media">
        <img src="/img/hero-guincho.webp" width="760" height="520" alt="Caminhão guincho da Auto Socorro Pedrinho transportando veículo" fetchPriority="high" data-testid="hero-image" />
        <div className="hero-floating-card" data-testid="hero-floating-card"><MapPinned size={20} /> Base na Rod. Presidente Dutra, Jardim Real</div>
      </div>
    </section>
  );
}